
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Sqmi", function(module, exports) {
/* ShortcutsDragContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9DHhW = parcelRequire("9DHhW");





var $lzgC6 = parcelRequire("lzgC6");

const $a8b3b36815423b52$export$8a2496cd6c012f98 = (0, $lzgC6.default)()(class OperationalEvent extends (0, $cozmU.Component) {
    componentDidMount() {
        this.sendOperationalEvent();
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.id !== this.props.id || nextProps.action !== this.props.action || nextProps.actionSubject !== this.props.actionSubject;
    }
    componentDidUpdate() {
        this.sendOperationalEvent();
    }
    sendOperationalEvent() {
        const { createAnalyticsEvent: createAnalyticsEvent, action: action, actionSubject: actionSubject, source: source, attributes: attributes, containerType: containerType, containerId: containerId } = this.props;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: actionSubject,
                source: source,
                containerType: containerType,
                containerId: containerId,
                attributes: attributes || null
            }
        }).fire();
    }
    render() {
        return null;
    }
});



var $7aRa9 = parcelRequire("7aRa9");


var $1NBp8 = parcelRequire("1NBp8");


var $luv00 = parcelRequire("luv00");

/* DraggableShortcutsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/self-closing-comp */ 






var $kSwu1 = parcelRequire("kSwu1");


var $bB0i2 = parcelRequire("bB0i2");


var $9kbTQ = parcelRequire("9kbTQ");


var $l8wPz = parcelRequire("l8wPz");


var $jdA6O = parcelRequire("jdA6O");


var $4yYAm = parcelRequire("4yYAm");


var $QXwxo = parcelRequire("QXwxo");


var $5wHqn = parcelRequire("5wHqn");


var $gyUf8 = parcelRequire("gyUf8");


var $iSrRp = parcelRequire("iSrRp");


var $aDtKq = parcelRequire("aDtKq");


var $21ejV = parcelRequire("21ejV");


var $j6wrK = parcelRequire("j6wrK");


var $cDMxg = parcelRequire("cDMxg");


var $fYWmN = parcelRequire("fYWmN");


var $aqP4n = parcelRequire("aqP4n");


var $vZEJe = parcelRequire("vZEJe");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $jmjWc = parcelRequire("jmjWc");


var $dPJCf = parcelRequire("dPJCf");





var $56QzY = parcelRequire("56QzY");


var $6mKj3 = parcelRequire("6mKj3");


var $1AV5C = parcelRequire("1AV5C");


var $9wGTI = parcelRequire("9wGTI");


var $h4oCC = parcelRequire("h4oCC");


const $8bcdd2b9838a59f9$var$LinkPickerWithPlugin = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Etfos",
    name: "LinkPickerWithPlugin",
    loader: async ()=>(await (parcelRequire("dEl8M"))).LinkPickerWithPlugin
});
const $8bcdd2b9838a59f9$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.__SSR_RENDERED__;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bcdd2b9838a59f9$var$DragPreview = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4lere _2rkofajl _11q7hp5a _1pxwftgi _1e0c1txw _4cvr1h6o _vchhusvi _1bsbdlvw _1bah1yb4 _syazazsu _43dsd34b _1cvzglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Legacy = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { draggableState: draggableState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko1l7b _80om73ad _kqswh2mm _c71l1ylp _1bfhidpf _ncow1dpa _t6db1j28 _1uyw1dpa _7k461aqn _5hvf1rpy _1kzckb7n _n5sikb7n _1j6mf1ug _9vpt1osq _1vjv1txw _1dsjidpf _hpfx19bv _1pi6idpf _1rqg19bv _j8ve1gyu _d8gsu2gc _1m7d1ylp _nfqw1h6o _mig07vkz _rqui7vkz _1mfy7vkz _1tlu7vkz _1uzz7vkz _1nao7vkz _1knu7vkz _1m537vkz _18387vkz _5fr87vkz _1x8p7vkz _3uc87vkz _dgj27vkz _f2tv7vkz _ors87vkz _19q77vkz _drvf7vkz _dz5k7vkz _1xdi7vkz _1mjq7vkz _1ozr7vkz _p4o77vkz _b4047vkz _1hlo7vkz _1f4k7vkz _1c2c7vkz _6ghj7vkz _wc727vkz _ppk67vkz _12it7vkz _1p521txw _1n2o1txw _1v241txw _1o8v1txw _t8q21txw _y3u81h6o _3zzm1h6o _aird1h6o _rcsr1h6o _19fb1h6o _1wjbi7uo _109o1ylp _1c877vkz _1so97vkz _1s5b7vkz _1uhy7vkz _1bti7vkz _10zm7vkz _16nc7vkz _1ilt7vkz _1t827vkz _rcgi7vkz _uyp97vkz _cbv57vkz _142w7vkz _1fe57vkz _1cld7vkz _3h3j7vkz _1emvnkob _1lbdnkob _az5onkob _w68onkob _109o14no _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43dsazsu _p03cazsu _oavvazsu _oxk4azsu _1cayazsu _13uifcek _j0cz1osq _jdednpx7 _15kb6x5g _13ozidpf _1nypidpf _yuv7idpf _hrieidpf _13wbidpf _aliv1tcg _p1061tcg _13i61tcg _1cayd34b _irr31dpa",
            __cmplp.draggableState === 'dragging' ? "_tzy41ck0" : "_tzy4kb7n",
            __cmplp.draggableState === 'idle' ? "_jomr1dpa _10j71dpa _irr31dpa" : "_jomr1wug _10j71wug _irr31wug",
            __cmplp.draggableState === 'idle' ? "_1y9g1kr1 _1rhokb7n" : "_1rhoidpf",
            !$8bcdd2b9838a59f9$export$a8c2f05884e8c7a1() && "_cs4c15vq _lgpm15vq _jt20idpf _1vm1or1b _1xsaidpf _1l4e1crf _1p7a1r31 _hg20glyw _1lv6nqa1 _nn7ofhey _19y2178v _t41dlb4i _11r2b3bt _hy7n1o8l _i2xg14yf _1som14yf _wvd5h2mm _1jz6i2wt _avkbidpf _1h687vkz _1086glyw _19i6f0ml _fncgmgnk _1v9m6rms _olwp9cwz _1cxzq7pw _19iy12c5 _tf7r13g8 _6fdwp3kn _9sps1o8l _o6dk1osq _1yd81ylp _7vnk1ylp _1wpyusvi _v2ut1q9c _l5tc1l2s _1c279jpi _1t5x1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Tokenized = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { draggableState: draggableState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko12b0 _80om73ad _kqswh2mm _c71l1ylp _1bfhidpf _ncow1dpa _t6db1j28 _1uyw1dpa _7k461aqn _5hvf1rpy _1kzckb7n _n5sikb7n _1j6mf1ug _9vpt1osq _1vjv1txw _1dsjidpf _hpfx19bv _1pi6idpf _1rqg19bv _j8ve1gyu _d8gsu2gc _1m7d1ylp _nfqw1h6o _mig07vkz _rqui7vkz _1mfy7vkz _1tlu7vkz _1uzz7vkz _1nao7vkz _1knu7vkz _1m537vkz _18387vkz _5fr87vkz _1x8p7vkz _3uc87vkz _dgj27vkz _f2tv7vkz _ors87vkz _19q77vkz _drvf7vkz _dz5k7vkz _1xdi7vkz _1mjq7vkz _1ozr7vkz _p4o77vkz _b4047vkz _1hlo7vkz _1f4k7vkz _1c2c7vkz _6ghj7vkz _wc727vkz _ppk67vkz _12it7vkz _1p521txw _1n2o1txw _1v241txw _1o8v1txw _t8q21txw _y3u81h6o _3zzm1h6o _aird1h6o _rcsr1h6o _19fb1h6o _1wjbi7uo _109o1ylp _1c877vkz _1so97vkz _1s5b7vkz _1uhy7vkz _1bti7vkz _10zm7vkz _16nc7vkz _1ilt7vkz _1t827vkz _rcgi7vkz _uyp97vkz _cbv57vkz _142w7vkz _1fe57vkz _1cld7vkz _3h3j7vkz _1emvnkob _1lbdnkob _az5onkob _w68onkob _109o14no _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43dsazsu _p03cazsu _oavvazsu _oxk4azsu _1cayazsu _13uifcek _j0cz1osq _jdednpx7 _15kb6x5g _13ozidpf _1nypidpf _yuv7idpf _hrieidpf _13wbidpf _aliv1tcg _p1061tcg _13i61tcg _1cayd34b _irr31dpa",
            __cmplp.draggableState === 'dragging' ? "_tzy41ck0" : "_tzy4kb7n",
            __cmplp.draggableState === 'idle' ? "_jomr1dpa _10j71dpa _irr31dpa" : "_jomr1wug _10j71wug _irr31wug",
            __cmplp.draggableState === 'idle' ? "_1y9g1kr1 _1rhokb7n" : "_1rhoidpf",
            !$8bcdd2b9838a59f9$export$a8c2f05884e8c7a1() && "_cs4c15vq _lgpm15vq _jt20idpf _1vm1or1b _1xsaidpf _1l4e1crf _1p7a1r31 _hg20glyw _1lv6nqa1 _nn7ofhey _19y2178v _t41dlb4i _11r2b3bt _hy7n1o8l _i2xg14yf _1som14yf _wvd5h2mm _1jz6i2wt _avkbidpf _1h687vkz _1086glyw _19i6f0ml _fncgmgnk _1v9m6rms _olwp9cwz _1cxzq7pw _19iy12c5 _tf7r13g8 _6fdwp3kn _9sps1o8l _o6dk1osq _1yd81ylp _7vnk1ylp _1wpyusvi _v2ut1q9c _l5tc1l2s _1c279jpi _1t5x1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Wrapper for feature-flagged styled container (go/DSP-18766)
const $8bcdd2b9838a59f9$export$c318e931097be377 = (props)=>{
    const Component = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Tokenized : $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Legacy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
};
const $8bcdd2b9838a59f9$var$itemStyles = {
    base: "_2rkofajl _kqswh2mm _4t3izwfg _19pkidpf _fj131y44 _k1o11y44 _1rgb1y44 _mto2ftgi _1h2b18uv _ekv6fhey _1ufy15vq _turg15vq _1lb9idpf _43dsd34b _bpsp1wq8 _hstc1u1b _9r1zxy5q _1hw71ule _2cf31l2s _sjfo1q9c _f8z6idpf _qzhyidpf _1m2nidpf _15kaidpf _1jkvu2gc _jzj9cj1k _4pm24jg8 _plbeidpf _1xqcplhp _vw87f705 _1wg6stnw _j8vb19bv _1o2dyh40 _1aum1crf _11nm1tcg _y0rh1wug _36ko1r8n _13hu1q5k _14hp1tcg _jq8g1tcg _dpd31txw _xlob1h6o _12no1h6o _jmnr1j28 _13hbd34b _k6cg1crf _1d421crf _rfqo1r31 _1bgkglyw _1t0pnqa1 _3ifa1dpa _irr31dpa",
    dragging: "_tzy41ck0",
    isMenuOpen: "_1kx4fcek"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bcdd2b9838a59f9$var$PopupTrigger = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1aaxusic _p12fidpf _c71lidpf _3um015vq",
            __cmplp.className
        ])
    });
});
const $8bcdd2b9838a59f9$var$i18n = (0, $kSwu1.defineMessages)({
    shortcutsQuickActionsRemoveButton: {
        id: "space-shortcuts.shortcuts.quick-actions.remove",
        defaultMessage: "Remove"
    },
    draggableItemLabel: {
        id: "space-shortcuts.draggable-item.label",
        defaultMessage: "{title} draggable item"
    }
});
const $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE = 'shortcuts-item'; // string begins with 1+ characters other than "/", has a "/", and is followed by one character other than "/"
// OR string begins with "/", is followed by 1 character other than "/", ends with any # of any character
// while ignoring capitalization
const $8bcdd2b9838a59f9$var$relativeUrlMatch = new RegExp(`^[^\/]+\/[^\/].*$|^\/[^\/].*$`, 'i'); // adding domain to relative confluence URLs so smart links don't error
const $8bcdd2b9838a59f9$export$2414511207262909 = (url, isExternal)=>{
    if (url === null) return url;
    if (!isExternal && $8bcdd2b9838a59f9$var$relativeUrlMatch.test(url)) return window.location.origin + url;
     // edge case that doesn't match regexp
    if (url.match(`${window.location.protocol}///wiki`)) return window.location.origin + url.replace(`${window.location.protocol}//`, '');
    return url;
};
const $8bcdd2b9838a59f9$export$69a9b8d15b4aa378 = ({ flags: flags, item: item, index: index, spaceId: spaceId, createAnalyticsEvent: createAnalyticsEvent, isSpaceAdmin: isSpaceAdmin, links: links, deleteShortcut: deleteShortcut, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
    const ref = (0, $cozmU.useRef)(null);
    const refPreview = (0, $cozmU.useRef)(null);
    const intl = (0, $kSwu1.useIntl)();
    const CardComponent = $8bcdd2b9838a59f9$export$a8c2f05884e8c7a1() ? (0, $QXwxo.CardSSR) : (0, $l8wPz.Card);
    let { url: url, styleClass: styleClass } = item;
    url = url || '';
    const { title: title = '', id: id } = item; //styleClass is the old way of knowing if a link was internal or external
    styleClass = styleClass || '';
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    let target = '_blank', navdexPointType = null;
    try {
        const isRelativeUrl = matchRoute(url);
        const includesHostName = url.includes(window.location.hostname);
        const containsExternalStyleClass = styleClass.indexOf('external_link') >= 0; //now we also check if the link is relative or contains the pathname, falls back to styleclass
        const isExternal = !(isRelativeUrl || includesHostName) && containsExternalStyleClass;
        url = $8bcdd2b9838a59f9$export$2414511207262909(url, isExternal) || '';
        target = isExternal ? '_blank' : '_self';
        navdexPointType = !isExternal ? (0, $56QzY.START_TOUCH) : null;
    } catch  {
        // eslint-disable-next-line no-console
        console.warn('malformed URL:', url); //prefer to show a different UI when the link is bad, letting the user know they should update the shortcut...
    //however the smartcard format doesn't really have a way to do this.
    }
    const [isEditOpen, setIsEditOpen] = (0, $cozmU.useState)(false);
    const [isActionMenuOpen, setIsActionMenuOpen] = (0, $cozmU.useState)(false);
    const [closestEdge, setClosestEdge] = (0, $cozmU.useState)(null);
    const [draggableState, setDraggableState] = (0, $cozmU.useState)('idle');
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsEditOpen(false);
    }, [
        setIsEditOpen
    ]);
    const openEdit = (0, $cozmU.useCallback)(()=>{
        setIsEditOpen(!isEditOpen);
    }, [
        isEditOpen,
        setIsEditOpen
    ]);
    const handleSubmit = (0, $h4oCC.useEditShortcut)(links, flags, spaceId);
    const onSubmit = (0, $cozmU.useCallback)((href, displayText)=>{
        handleSubmit({
            id: id,
            url: href,
            title: displayText || ''
        });
        handleClose();
    }, [
        handleClose,
        handleSubmit,
        id
    ]);
    const location = 'confluenceShortcuts';
    const sendShortcutClickedAnalytics = (navdexPointType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'spaceShortcut',
                    source: 'containerNavigation',
                    containerType: 'space',
                    containerId: spaceId,
                    attributes: {
                        navVersion: '3',
                        ...navdexPointType && {
                            navdexPointType: navdexPointType
                        },
                        location: location
                    }
                }
            }).fire();
        };
    (0, $cozmU.useEffect)(()=>{
        if (!isSpaceAdmin && (0, $6mKj3.expVal)('confluence_frontend_js_reduction-shortcuts', 'isEnabled', false)) return;
        (0, $bB0i2.default)(ref.current);
        return (0, $aDtKq.combine)((0, $iSrRp.draggable)({
            element: ref.current,
            onGenerateDragPreview: ({ source: source, nativeSetDragImage: nativeSetDragImage })=>{
                (0, $j6wrK.scrollJustEnoughIntoView)({
                    element: source.element
                });
                (0, $cDMxg.setCustomNativeDragPreview)({
                    getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render: ({ container: container })=>{
                        // eslint-disable-next-line react/no-deprecated
                        (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bcdd2b9838a59f9$var$DragPreview, {
                            ref: refPreview
                        }), container);
                        if (refPreview.current) refPreview.current.innerHTML = ref.current?.innerHTML ?? '';
                         // eslint-disable-next-line react/no-deprecated
                        return ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(container);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                setDraggableState('dragging');
                onDragStart && onDragStart();
            },
            getInitialData: ()=>({
                    id: item.id,
                    type: $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE
                }),
            // attach a url for other documents and applications
            getInitialDataForExternal: ()=>{
                if (!url) return {};
                return {
                    'text/uri-list': url
                };
            },
            onDrop: ()=>{
                setDraggableState('idle');
            }
        }), (0, $iSrRp.dropTargetForElements)({
            element: ref.current,
            canDrop: ({ source: source })=>{
                return source.data.type === $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE;
            },
            getData: ({ input: input, element: element })=>{
                const data = {
                    id: item.id,
                    type: $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE,
                    index: index
                };
                return (0, $aqP4n.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag: ({ self: self, source: source, location: location })=>{
                if (source.data.id !== item.id && location?.current?.dropTargets[0]?.data?.id === item.id) setClosestEdge((0, $aqP4n.extractClosestEdge)(self.data));
                else setClosestEdge(null);
            },
            onDragLeave: ()=>{
                setClosestEdge(null);
            },
            onDrop: ({ location: location })=>{
                if (location?.current?.dropTargets[0]) {
                    const { data: target } = location.current.dropTargets[0];
                    const { data: source } = location.initial.dropTargets[0];
                    const edge = (0, $aqP4n.extractClosestEdge)(target);
                    if (!target || !target.id || target.type !== $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE || target.id === item.id && !edge) return;
                    const sourcePosition = {
                        index: source.index
                    };
                    const destinationPosition = {
                        index: (0, $21ejV.getReorderDestinationIndex)({
                            startIndex: source.index,
                            indexOfTarget: target.index,
                            closestEdgeOfTarget: edge,
                            axis: 'vertical'
                        })
                    };
                    if (sourcePosition.index !== destinationPosition.index) onDragEnd(sourcePosition, destinationPosition);
                }
                setClosestEdge(null);
            }
        }));
    }, [
        isSpaceAdmin,
        onDragStart,
        onDragEnd,
        item,
        index,
        url
    ]);
    const disableNativeDragOnLinks = ()=>{
        if (!ref.current) return;
        Array.from(ref.current.querySelectorAll('a')).forEach((anchor)=>anchor.setAttribute('draggable', 'false'));
    };
    const handleComplete = ()=>{
        disableNativeDragOnLinks();
    };
    const handleCompleteError = ()=>{
        disableNativeDragOnLinks();
    };
    const hash = (0, $1AV5C.hashData)(`${title}-${url}`);
    const placeholderId = `shortcut-item-${index}-${hash}`;
    const itemContent = // TODO: Add `shouldRenderToParent={true}` to meet a11y requirements. See
    // https://a11y.atlassian.net/browse/JCATS-788
    // https://hello.jira.atlassian.cloud/browse/DISCO-4293
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
        testId: "shortcut-item",
        appearance: "inline",
        url: url || '',
        placeholder: title || undefined,
        onClick: sendShortcutClickedAnalytics(navdexPointType),
        onResolve: handleComplete,
        onError: handleCompleteError,
        ui: {
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            clickableContainer: true,
            size: (0, $4yYAm.SmartLinkSize).Medium
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        text: title || undefined,
        anchorTarget: target,
        hideTitleTooltip: true,
        actions: isSpaceAdmin ? [
            {
                name: (0, $4yYAm.ActionName).EditAction,
                onClick: openEdit,
                iconPosition: 'before',
                testId: 'editAction'
            },
            {
                name: (0, $4yYAm.ActionName).DeleteAction,
                onClick: ()=>deleteShortcut(item),
                iconPosition: 'before',
                testId: 'deleteAction',
                content: intl.formatMessage($8bcdd2b9838a59f9$var$i18n.shortcutsQuickActionsRemoveButton)
            }
        ] : undefined,
        showActionOnHover: true,
        onActionMenuOpenChange: ({ isOpen: isOpen })=>{
            setIsActionMenuOpen(isOpen);
        },
        placeholderId: placeholderId
    })), (isEditOpen || isActionMenuOpen || !(0, $6mKj3.expVal)('confluence_frontend_js_reduction-shortcuts', 'isEnabled', false)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        autoFocus: false,
        isOpen: isEditOpen,
        onClose: ()=>handleClose(),
        content: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bcdd2b9838a59f9$var$LinkPickerWithPlugin, {
                ...props,
                onSubmit: ({ url: url, displayText: displayText })=>{
                    onSubmit(url, displayText);
                },
                onCancel: handleClose,
                url: url || '',
                displayText: title || ''
            })),
        placement: "bottom-start",
        offset: [
            -42,
            4
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bcdd2b9838a59f9$var$PopupTrigger, triggerProps)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
        testId: "space-shortcuts-actions-blanket",
        isTinted: false,
        shouldAllowClickThrough: !isEditOpen && !isActionMenuOpen,
        onBlanketClicked: ()=>{
            setIsActionMenuOpen(false);
            setIsEditOpen(false);
        }
    })), closestEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: closestEdge
    }) : null);
    const isMenuOpen = isActionMenuOpen || isEditOpen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "li",
        ref: ref,
        "aria-label": intl.formatMessage($8bcdd2b9838a59f9$var$i18n.draggableItemLabel, {
            title: title
        }),
        xcss: (0, $w6R6I.cx)($8bcdd2b9838a59f9$var$itemStyles.base, $8bcdd2b9838a59f9$var$itemStyles[draggableState], isMenuOpen && $8bcdd2b9838a59f9$var$itemStyles.isMenuOpen)
    }, itemContent);
};
const $8bcdd2b9838a59f9$export$a115102ddf435124 = (0, $7aRa9.withFlags)($8bcdd2b9838a59f9$export$69a9b8d15b4aa378);





// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42c81fda1a12071e$var$ShortcutsListContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            __cmplp.className
        ])
    });
});
const $42c81fda1a12071e$var$ShortcutsDragContainerComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ flags: flags, isSpaceAdmin: isSpaceAdmin, links: links, spaceId: spaceId, spaceKey: spaceKey, shortcutsHistoryRef: shortcutsHistoryRef })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { moveShortcut: moveShortcut, undoMoveShortcut: undoMoveShortcut } = (0, $h4oCC.useMoveShortcut)(links, flags, shortcutsHistoryRef);
    const { deleteShortcut: deleteShortcut, undoDeleteShortcut: undoDeleteShortcut } = (0, $h4oCC.useDeleteShortcut)(links, flags, shortcutsHistoryRef);
    const hideLastUndoFlag = ()=>{
        // hides previous success flag so that only one is on the screen at a time
        const lastMovement = shortcutsHistoryRef.current.peek();
        if (lastMovement) flags.hideFlag(lastMovement.flagId);
    };
    const onDeleteShortcut = (item)=>{
        hideLastUndoFlag();
        deleteShortcut(item);
        shortcutsHistoryRef.current.push({
            undo: ()=>undoDeleteShortcut(item),
            // makes the confirmation flag display the message reflecting only the latest change
            lastDeletedItem: item
        });
    };
    const onDragStart = async ()=>{
        // hides the success flag when moving a subsequent shortcut
        hideLastUndoFlag();
    };
    const onDragEnd = async (source, destination)=>{
        hideLastUndoFlag();
        moveShortcut(source, destination);
        shortcutsHistoryRef.current.push({
            undo: ()=>{
                undoMoveShortcut(source);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'undo',
                        actionSubject: 'update',
                        actionSubjectId: 'spaceShortcuts',
                        source: 'viewPageScreen',
                        attributes: {
                            previousRank: source,
                            newRank: destination,
                            action: 'reorder'
                        }
                    }
                }).fire();
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'updated',
                actionSubject: 'spaceShortcuts',
                source: 'viewPageScreen',
                attributes: {
                    previousRank: source,
                    newRank: destination,
                    action: 'reorder'
                }
            }
        }).fire();
    };
    const displayLinks = (0, $cozmU.useMemo)(()=>Array.from(links).reverse(), [
        links
    ]);
    const pageIds = displayLinks.filter((item)=>(item.styleClass || '').indexOf('external_link') < 0).filter((item)=>(0, $1NBp8.VIEW_PAGE).match(item.url || '')).map((item)=>(0, $1NBp8.VIEW_PAGE).match(item.url || '')?.params.contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($42c81fda1a12071e$var$ShortcutsListContainer, {
        "data-vc": "shortcuts-drag-container",
        ...ssrPlaceholderIdProp
    }, displayLinks.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bcdd2b9838a59f9$export$a115102ddf435124), {
            key: `shortcuts-item-${item?.id || index}`,
            item: item,
            index: index,
            spaceId: spaceId,
            createAnalyticsEvent: createAnalyticsEvent,
            isSpaceAdmin: isSpaceAdmin,
            links: links,
            deleteShortcut: onDeleteShortcut,
            onDragStart: onDragStart,
            onDragEnd: onDragEnd
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a8b3b36815423b52$export$8a2496cd6c012f98), {
        id: spaceKey,
        action: "initialized",
        actionSubject: "spaceShortcutsSection",
        source: "dashboard",
        containerType: "space",
        containerId: spaceId,
        attributes: {
            navVersion: '3',
            numOfShortcuts: links.length,
            pageIds: pageIds
        },
        createAnalyticsEvent: createAnalyticsEvent
    }));
});
const $42c81fda1a12071e$export$e03e20755e26b5e9 = (0, $7aRa9.withFlags)($42c81fda1a12071e$var$ShortcutsDragContainerComponent);
module.exports["ShortcutsDragContainer"] = $42c81fda1a12071e$export$e03e20755e26b5e9;

});

parcelRegister("21ejV", function(module, exports) {
function $cbf58e886ee3aa4f$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}
module.exports["getReorderDestinationIndex"] = $cbf58e886ee3aa4f$export$846f792f51b92b6e;

});

parcelRegister("aqP4n", function(module, exports) {
const $03a217ae6d97834d$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $03a217ae6d97834d$var$uniqueKey = Symbol('closestEdge');
function $03a217ae6d97834d$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $03a217ae6d97834d$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$03a217ae6d97834d$var$uniqueKey]: addClosestEdge
    };
}
function $03a217ae6d97834d$export$945a571f3b658bf(userData) {
    return userData[$03a217ae6d97834d$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $03a217ae6d97834d$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $03a217ae6d97834d$export$945a571f3b658bf;

});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("dEl8M", function(module, exports) {

let $9eff68e35d11284f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9eff68e35d11284f$var$load("h5kct"),
    $9eff68e35d11284f$var$load("7TnhR"),
    $9eff68e35d11284f$var$load("hzkGb"),
    $9eff68e35d11284f$var$load("aClTZ"),
    $9eff68e35d11284f$var$load("hZ2FX"),
    $9eff68e35d11284f$var$load("hUbK8"),
    $9eff68e35d11284f$var$load("hS8gF"),
    $9eff68e35d11284f$var$load("g8A75"),
    $9eff68e35d11284f$var$load("1Gr4q"),
    $9eff68e35d11284f$var$load("4RsKm"),
    $9eff68e35d11284f$var$load("7G12e"),
    $9eff68e35d11284f$var$load("fuOfV"),
    $9eff68e35d11284f$var$load("iZR3N"),
    $9eff68e35d11284f$var$load("jXM1T"),
    $9eff68e35d11284f$var$load("cvcNg"),
    $9eff68e35d11284f$var$load("aIze1"),
    $9eff68e35d11284f$var$load("6wr18"),
    $9eff68e35d11284f$var$load("4N1MY"),
    $9eff68e35d11284f$var$load("ffEVr"),
    $9eff68e35d11284f$var$load("fFddv")
]).then(()=>parcelRequire('7Wd2W'));

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("1LXnB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $12a75cc47e499450$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $12a75cc47e499450$export$2e2bcd8739ae039 = $12a75cc47e499450$var$WidthObserver;
module.exports["default"] = $12a75cc47e499450$export$2e2bcd8739ae039;

});

parcelRegister("69NJe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("rECdA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("8m50u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $fb7caad66dba5065$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $fb7caad66dba5065$export$6e8ea24b15199873;

});

parcelRegister("kMzDv", function(module, exports) {
$parcel$export(module.exports, "auth", () => (parcelRequire("eEPSE")).auth);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("7zxJs")).AuthError);

var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


});

parcelRegister("eEPSE", function(module, exports) {

var $7zxJs = parcelRequire("7zxJs");


var $75u2V = parcelRequire("75u2V");

function $4e31e5414e67a93e$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $75u2V.isOfTypeAuthError)(errorType)) reject(new (0, $7zxJs.AuthError)(data.message, errorType));
                    else reject(new (0, $7zxJs.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $7zxJs.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $4e31e5414e67a93e$export$73693bad9f5880b0;

});

parcelRegister("7zxJs", function(module, exports) {
class $dd3fe40c981b3bd9$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $dd3fe40c981b3bd9$export$145273558d58e0ac;

});

parcelRegister("75u2V", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $6f56de9d96dc4f7f$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $6f56de9d96dc4f7f$export$400e64c8451aa84f;

});

parcelRegister("hyOTw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $52c0c0ab9e795973$var$placeholderShimmer = null;
const $52c0c0ab9e795973$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $52c0c0ab9e795973$var$spanSkeletonStyles = null;
const $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $52c0c0ab9e795973$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $52c0c0ab9e795973$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $52c0c0ab9e795973$export$2e2bcd8739ae039 = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $52c0c0ab9e795973$export$85d5658002cae6ce;
module.exports["Skeleton"] = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;

});


//# sourceMappingURL=ShortcutsDragContainer.6790a17f.js.map
